<i18n>
{
    "de": {
        "mpsk_description_title": "Was ist SW-KA-IoT?",
        "mpsk_description_text": [
          "Für das reguläre WLAN-Netz in den Wohnheimen (SW-KA) ist eine Anmeldung mittels Nutzernamen und Passwort notwendig. Leider unterstützen gewisse Geräte (wie z. B. IoT-Geräte, Streaming-Sticks oder einige Spielkonsolen) dieses Anmeldeverfahren nicht.",
          "Für diesen Zweck stellen wir das WLAN-Netz SW-KA-IoT bereit.",
          "Hierfür müssen Sie ihr Gerät auf dieser Seite registrieren und können dann mit einem individuellen Passwort das Netzwerk \"SW-KA-IoT\" mit diesem Gerät nutzen. Zur Registrierung benötigen Sie die MAC-Adresse des Gerätes (manchmal auch \"physische Adresse\" genannt). Diese finden sie entweder aufgedruckt auf dem Gerät, oder in den Netzwerk- oder Systemeinstellungen."
        ],
        "wifi_none": "WLAN leider nicht verfügbar.",
        "mpsk_my_devices": "Meine Geräte",
        "mpsk_add": "Gerät hinzufügen",
        "mpsk_label": "Bezeichnung",
        "mpsk_label_good": "Bezeichnung gültig.",
        "mpsk_label_error": "Die Bezeichnung muss länger als 3 Zeichen sein.",
        "mpsk_pw": "Gerätekennwort",
        "mpsk_pw_good": "Passwort gültig.",
        "mpsk_pw_none": "Kein Passwort erforderlich",
        "mpsk_pw_error": "Ihr Gerätekennwort muss zwischen 8 und 63 Zeichen lang sein.",
        "mpsk_mac": "MAC-Adresse des Geräts",
        "mpsk_mac_good": "MAC-Adresse gültig.",
        "mpsk_mac_error": "MAC-Adresse ungültig.",
        "last_login_date": "Letzte Nutzung",
        "last_login_node": "Letzter Zugangspunkt"
    },
    "en": {
      "mpsk_description_title": "What is SW-KA-IoT?",
      "mpsk_description_text": [
        "For the regular Wi-Fi network in the dorms (SW-KA), a login via username and password is required. Unfortunately, certain devices (such as IoT devices, streaming sticks or some gaming consoles) do not support this login procedure.",
        "For this purpose, we provide the SW-KA-IoT Wi-Fi network.",
        "To do this, you must register your device on this page and can then use the network \"SW-KA-IoT\" with this device using an individual password. For registration you need the MAC address of the device (sometimes also called \"physical address\"). You can find this either printed on the device or in the network or system settings."
      ],
      "wifi_none": "Unfortunately, Wi-Fi is not (yet) available.",
      "mpsk_my_devices": "My Devices",
      "mpsk_add": "Add Device",
      "mpsk_label": "Device Label",
      "mpsk_label_good": "Label valid.",
      "mpsk_label_error": "Your device label must be longer than 3 characters.",
      "mpsk_pw": "Device Password",
      "mpsk_pw_good": "Password valid.",
      "mpsk_pw_none": "No password needed",
      "mpsk_pw_error": "Your device password must be between 8 and 63 characters.",
      "mpsk_mac": "Device MAC Address",
      "mpsk_mac_good": "MAC Address valid.",
      "mpsk_mac_error": "MAC Address invalid.",
      "last_login_date": "Last used",
      "last_login_node": "Last origin"
    }
}
</i18n>

<template>
  <div class="account_mpsk">
    <Loading :data="[dorm, devices]">
      <div v-if="dorm">
        <h1>SW-KA-IoT</h1>
        <h3>{{$t('mpsk_description_title')}}</h3>
        <p v-for="phrase in $t('mpsk_description_text')" v-bind:key="phrase">{{ phrase }}</p>

        <br>
        <hr>
        <br>

        <!--<div v-if="dorm.wifi_available != 'none'">-->
        <div v-if="dorm.wifi_available == 'none'">
          <p class="text-danger" style="display: flex; align-items: center;">
            <b-icon-wifi-off style="width: 60px; height: 60px;"></b-icon-wifi-off>
            {{ $t('wifi_none') }}
          </p>
        </div>
        <div v-else>
          <h3>{{$t('mpsk_my_devices')}}</h3>

          <br>
          <b-button @click="deviceModal()" variant="primary">{{$t("mpsk_add")}}</b-button>
          &nbsp;
          &nbsp;
          <b-button @click="showPW = !showPW" variant="warning">{{$t("system.toggle_pw")}}</b-button>
          <br>
          <br>

          <b-table :items="devices" :fields="mpsk_table_fields">
            <template v-slot:cell(psk)="data">
              <span v-if="showPW">{{ data.item.psk }}</span>
              <span v-else>{{ data.item.psk.replace(/./g, '*') }}</span>
            </template>

            <template v-slot:cell(actions)="data">
              <b-button variant="danger" @click="delete_device(data.item.id)">
                <font-awesome-icon :icon="['fas', 'trash-alt']"></font-awesome-icon>
                {{ $t('system.delete_device') }}
              </b-button>
            </template>
          </b-table>
        </div>
      </div>

      <b-modal id="device-assign" ref="modal" :title="$t('mpsk_add')" no-close-on-backdrop :ok-title="$t('system.save')" @ok="handleOk" :cancel-title="$t('system.cancel')" size="lg">
        <b-form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group>
            <label for="mpsk-label">{{$t("mpsk_label")}}</label>
            <b-form-input v-model="mpsk_label" :state="validationLabel" id="mpsk-label"></b-form-input>
            <b-form-invalid-feedback :state="validationLabel">
              {{$t("mpsk_label_error")}}
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="validationLabel">
              {{$t("mpsk_label_good")}}
            </b-form-valid-feedback>
          </b-form-group>

          <b-form-group :disabled="enforcedPSK != null">
            <label for="mpsk-pw">{{$t("mpsk_pw")}}</label>
            <b-form-input v-model="mpsk_pw" type="password" :state="validationPW" id="mpsk-pw"></b-form-input>
            <b-form-invalid-feedback :state="validationPW">
              {{$t("mpsk_pw_error")}}
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="validationPW" v-if="enforcedPSK != null">
              {{$t("mpsk_pw_none")}}
            </b-form-valid-feedback>
            <b-form-valid-feedback :state="validationPW" v-else>
              {{$t("mpsk_pw_good")}}
            </b-form-valid-feedback>
          </b-form-group>

          <b-form-group>
            <label for="mpsk-mac">{{$t("mpsk_mac")}}</label>
            <b-form-input v-model="mpsk_mac" :state="validationMAC" id="mpsk-mac"></b-form-input>
            <b-form-invalid-feedback :state="validationMAC">
              {{$t("mpsk_mac_error")}}
            </b-form-invalid-feedback>
            <b-form-valid-feedback :state="validationMAC">
              {{$t("mpsk_mac_good")}}
            </b-form-valid-feedback>
          </b-form-group>
        </b-form>
      </b-modal>

    </Loading>
  </div>
</template>

<script>

import DormService from '@/api-services/dorm.service';
import MpskService from '@/api-services/mpsk.service';
import {EventBus} from '@/eventbus';

import Loading from "../../components/Loading";

const MAC_REGEX = new RegExp("^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})|([0-9a-fA-F]{4}\\.[0-9a-fA-F]{4}\\.[0-9a-fA-F]{4})$");

export default {
  name: 'account_mpsk',
  components: {Loading},

  data() {
    return {
      dorm: null,
      devices: null,
      enforcedPSK: null,

      showPW: false,

      mpsk_label: '',
      mpsk_pw: null,
      mpsk_mac: '',

      mpsk_table_fields: [
        {
          label: this.$t('system.label'),
          key: 'label'
        },
        {
          label: this.$t('system.mac'),
          key: 'mac_addr'
        },
        {
            label: this.$t('last_login_date'),
            key: 'last_login_date'
        },
        {
            label: this.$t('last_login_node'),
            key: 'last_login_node'
        },
        {
          label: this.$t('mpsk_pw'),
          key: 'psk',
        },
        {
          label: this.$t('system.actions'),
          key: 'actions',
        },
      ]
    }
  },

  async mounted() {
    await this.refresh()
  },

  computed: {
    validationLabel() {
      return this.mpsk_label.length >= 4
    },

    validationPW() {
      if (this.enforcedPSK != null) return true;
      else if (this.mpsk_pw == null) return false
      else return this.mpsk_pw.length >= 8 && this.mpsk_pw.length <= 63
    },

    validationMAC() {
      return MAC_REGEX.test(this.mpsk_mac)
    },

    console: () => console,
    window: () => window,
  },

  methods: {
    async refresh() {
      this.dorm = (await DormService.getMyDorm()).data.dorm

      this.devices = (await MpskService.getAllDevices()).data
      console.log(this.devices)

      this.enforcedPSK = (await MpskService.enforcedPSK()).data
    },

    async delete_device(id) {
      await MpskService.deleteDevice(id)

      await this.refresh();
    },

    async deviceModal() {
      await this.$root.$nextTick()
      this.$root.$emit('bv::show::modal', 'device-assign')
    },

    async handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      await this.handleSubmit()
    },

    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.validationLabel || !this.validationPW || !this.validationMAC) {
        return
      }

      try {
        await MpskService.createDevice(this.mpsk_label, this.mpsk_pw, this.mpsk_mac)

        await this.$root.$nextTick()
        this.$root.$emit('bv::hide::modal', 'device-assign')

        await this.refresh()
      } catch (e) {
        EventBus.$emit('alert', {variant: 'danger', message: this.$t("errors.invalid_psk")})
      }
    }
  }

}

</script>
